import { useEffect, useState } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { LAYOUT } from '@/constants/testIds';

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return (
    <div
      data-testid={LAYOUT.offlineIndicator}
      className={`flex items-center gap-2 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider border-2 ${
        online
          ? 'border-stone-200 text-stone-700 bg-white'
          : 'border-amber-500 text-amber-700 bg-amber-50'
      }`}
    >
      {online ? <Wifi className="w-3.5 h-3.5" /> : <WifiOff className="w-3.5 h-3.5" />}
      <span>{online ? 'En ligne' : 'Hors ligne'}</span>
    </div>
  );
}
